import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Collapse,
  Grid,
  TextField,
  Typography,
  IconButton,
  Tooltip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import RefreshIcon from '@mui/icons-material/Refresh';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import SupportAgent from '@mui/icons-material/SupportAgent';
import { makeStyles } from '@mui/styles';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ApprovalProcess from 'src/components/ApprovalProcess';
import DirectionProcess from 'src/components/DirectionProcess';
import WebPoint from 'src/components/WebPoint';
import WebPointCancel from 'src/components/WebPointCancel';
import InvoiceRefund from 'src/components/InvoiceRefund';
import { getUserRole } from 'src/utils/Common';
import InputAdornment from '@mui/material/InputAdornment';
import axios from 'src/utils/axios';
import { generalFollowActions } from 'src/store/slices/generalFollowSlice';
import PaymentExpectedReceipt from './PaymentExpectedReceipt';

const useStyles = makeStyles((theme) => ({
  cardscontent: {
    minHeight: 400,
    width: '100%'
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  div: {
    fontWeight: 'bold',
    fontSize: '12px',
    width: '100%',
    textDecoration: 'underline'
  },
  div2: {
    fontSize: '12px',
    width: '100%',
    fontWeight: 'bold'
  },
  messageBox: {
    margin: '0px',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '1.43',
    letterSpacing: '0.01071em',
    color: '#b02121b0'
  },
  icerikBilgi: {
    margin: '0px',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '1.43',
    letterSpacing: '0.01071em',
    color: 'black',
    marginBottom: '7.5px'
  },
  mainCard: {
    border: '1px solid #e0e0e0',
    borderRadius: '16px',
    position: 'sticky',
    top: 140,
    zIndex: 8,
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    marginBottom: '16px'
  },
  cardHeader: {
    backgroundColor: '#f5f5f5',
    color: '#424242',
    padding: '10px 16px',
    cursor: 'move',
    borderBottom: '1px solid #e0e0e0',
    '& .MuiCardHeader-title': {
      fontSize: '12px',
      fontWeight: '700',
      letterSpacing: '0.5px'
    }
  },
  infoBox: {
    padding: '8px 12px',
    backgroundColor: '#F5F5F5',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    borderLeft: '3px solid #FF9800',
    marginBottom: '8px'
  },
  labelText: {
    fontWeight: '600',
    fontSize: '10px',
    color: '#757575',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '4px'
  },
  valueText: {
    fontSize: '12px',
    color: '#263238',
    fontWeight: '600'
  },
  chatCard: {
    marginBottom: '12px',
    borderRadius: '12px',
    border: '1px solid #e0e0e0',
    backgroundColor: '#fff'
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  },
  spinning: {
    animation: '$spin 1s linear infinite'
  }
}));

function InformationChat() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const userRole = getUserRole().Component;
  const Role = getUserRole().RoleId;

  const invoiceData = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  );
  const ChatData = useSelector(
    (state) => state.informationChatSlice.informationChat
  );
  const UpdatedInfoChat = useSelector(
    (state) => state.generalFollowSlice.updatedInfoChat
  );
  const [infoChatContent, setInfoChatContent] = React.useState('');
  const [collapsed, setCollapsed] = React.useState(false);
  const [refreshing, setRefreshing] = React.useState(false);

  var airConditionerModelCodes = [];
  const topProductIds = [18924, 27048, 28063];
  const airConditionerMainGroups = [30092, 24370, 18597];

  useEffect(() => {
    getAirConditionerModelCodes();
  }, []);

  function changeChatInfoContent(val) {
    dispatch(generalFollowActions.updateInfoChat(val));
    setInfoChatContent(val);
  }
  function DeleteVal() {
    dispatch(generalFollowActions.updateInfoChat(''));
    setInfoChatContent('');
  }

  const checkData = () => {
    if (
      invoiceData[0]?.Model?.ProductId &&
      airConditionerModelCodes.includes(invoiceData[0].Model.ProductId)
    ) {
      // ilgili veri bulundu.
      var tempData = JSON.parse(JSON.stringify(invoiceData));
      tempData[0].Exchange.IsAirConditionerProduct = 1;
      dispatch(generalFollowActions.updateNewData(tempData));
    } else {
      // İlgili veri bulunamadı veya yok.
      var tempData = JSON.parse(JSON.stringify(invoiceData));
      tempData[0].Exchange.IsAirConditionerProduct = 0;
      dispatch(generalFollowActions.updateNewData(tempData));
    }
  };

  const handleRefresh = () => {
    setRefreshing(true);
    getAirConditionerModelCodes();
    setTimeout(() => setRefreshing(false), 500);
  };

  const handleToggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const getAirConditionerModelCodes = () => {
    axios.get('/GetAirConditionerModels', {}).then((response) => {
      const data = response.data;
      data.forEach((i) => {
        airConditionerModelCodes.push(i.MODEL_KODU);
      });
      checkData();
    });
  };

  return (
    <>
      <Card className={classes.mainCard}>
        <CardHeader
          className={classes.cardHeader}
          avatar={<DragIndicatorIcon sx={{ color: '#FF9800' }} />}
          action={
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Tooltip title={collapsed ? 'Genişlet' : 'Daralt'}>
                <IconButton
                  onClick={handleToggleCollapse}
                  sx={{ color: '#FF9800' }}
                >
                  {collapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                </IconButton>
              </Tooltip>
            </Box>
          }
          title="İşlem Bilgileri ve Mesajlar"
        />
        <Collapse in={!collapsed} timeout="auto" unmountOnExit>
          <CardContent sx={{ padding: '12px' }}>
            <Box className={classes.infoBox}>
              <Typography className={classes.labelText}>
                Değişim Onay Türü
              </Typography>
              <Typography className={classes.valueText}>
                {invoiceData[0]?.Consumer?.UpTypeDesc
                  ? invoiceData[0]?.Consumer?.UpTypeDesc
                  : '-'}
                {' - '}
                {invoiceData[0]?.Consumer?.TypeDesc
                  ? invoiceData[0]?.Consumer?.TypeDesc
                  : '-'}
              </Typography>
            </Box>
            {Role?.filter((i) => i.ROLE_ID !== 11).length > 0 ? (
              <Box sx={{ marginTop: '8px' }}>
                <Box
                  sx={{
                    borderTop: '1px solid #E0E0E0',
                    paddingTop: '12px',
                    marginBottom: '12px'
                  }}
                />
                <Box
                  sx={{
                    maxHeight: 300,
                    overflowY: 'auto',
                    paddingRight: '4px',
                    marginBottom: '12px',
                    '&::-webkit-scrollbar': {
                      width: '6px'
                    },
                    '&::-webkit-scrollbar-track': {
                      background: '#f1f1f1',
                      borderRadius: '10px'
                    },
                    '&::-webkit-scrollbar-thumb': {
                      background: '#4CAF50',
                      borderRadius: '10px',
                      '&:hover': {
                        background: '#43A047'
                      }
                    }
                  }}
                >
                  {Object.keys(ChatData).length > 0 ? (
                    ChatData?.map((row, index) => (
                      <Box
                        key={index}
                        sx={{
                          marginBottom: '10px',
                          animation: 'fadeIn 0.3s ease-in'
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '6px',
                            paddingX: '4px'
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5
                            }}
                          >
                            <SupportAgent
                              sx={{ color: '#4CAF50', fontSize: 16 }}
                            />
                            <Typography
                              sx={{
                                fontWeight: '600',
                                fontSize: '11px',
                                color: '#424242'
                              }}
                            >
                              {row.ADSOYAD}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: '10px',
                                color: '#9E9E9E',
                                marginLeft: '8px'
                              }}
                            >
                              {row.ADIMTARIH}
                            </Typography>
                          </Box>
                          <Typography
                            sx={{
                              fontSize: '10px',
                              color: '#4CAF50',
                              fontWeight: '600',
                              backgroundColor: '#E8F5E9',
                              padding: '2px 8px',
                              borderRadius: '12px'
                            }}
                          >
                            {row.DURUMACIKLAMA}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            backgroundColor: '#FAFAFA',
                            padding: '10px 14px',
                            borderRadius: '12px',
                            borderLeft: '3px solid #4CAF50',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              boxShadow: '0 2px 6px rgba(76,175,80,0.15)',
                              transform: 'translateY(-1px)'
                            }
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: '12px',
                              fontWeight: '500',
                              color: '#263238',
                              lineHeight: 1.5,
                              wordBreak: 'break-word'
                            }}
                          >
                            {row.ACIKLAMA}
                          </Typography>
                        </Box>
                      </Box>
                    ))
                  ) : (
                    <Box
                      sx={{
                        textAlign: 'center',
                        padding: '40px 20px',
                        color: '#BDBDBD'
                      }}
                    >
                      <SupportAgent
                        sx={{ fontSize: 48, marginBottom: 2, opacity: 0.3 }}
                      />
                      <Typography
                        sx={{
                          fontSize: '12px',
                          color: '#9E9E9E'
                        }}
                      >
                        Henüz mesaj bulunmuyor
                      </Typography>
                    </Box>
                  )}
                </Box>
                <Box
                  sx={{
                    borderTop: '1px solid #E0E0E0',
                    paddingTop: '12px'
                  }}
                >
                  <TextField
                    id="input-with-icon-textfield"
                    label="Mesaj Ekle"
                    placeholder="Mesajınızı buraya yazın..."
                    size="small"
                    value={UpdatedInfoChat}
                    fullWidth
                    variant="outlined"
                    multiline
                    rows={2}
                    onChange={(event) => {
                      changeChatInfoContent(event.target.value);
                    }}
                    InputLabelProps={{
                      style: { fontSize: '11px', color: '#757575' }
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        backgroundColor: '#FAFAFA',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          backgroundColor: '#F5F5F5',
                          borderColor: '#4CAF50'
                        },
                        '&.Mui-focused': {
                          backgroundColor: '#FFF',
                          boxShadow: '0 0 0 2px rgba(76,175,80,0.1)'
                        }
                      },
                      '& .MuiOutlinedInput-input': {
                        fontSize: '12px'
                      }
                    }}
                    InputProps={{
                      endAdornment: UpdatedInfoChat && (
                        <InputAdornment position="end">
                          <Tooltip title="Mesajı Temizle">
                            <IconButton
                              size="small"
                              onClick={() => {
                                DeleteVal();
                              }}
                              sx={{
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  backgroundColor: '#FFEBEE',
                                  transform: 'scale(1.1)'
                                }
                              }}
                            >
                              <DeleteIcon
                                sx={{ color: '#F44336', fontSize: 18 }}
                              />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      )
                    }}
                  />
                </Box>
              </Box>
            ) : null}
          </CardContent>
        </Collapse>
      </Card>
      {[23, 24, 25, 27, 28, 29].includes(invoiceData[0]?.Exchange?.Status) &&
      invoiceData[0]?.Exchange?.SubStatus === 22 &&
      airConditionerMainGroups.includes(invoiceData[0]?.Model?.MainGroupId) &&
      [1, 2].includes(invoiceData[0]?.Consumer?.ConsumerType) ? (
        <Grid item xs={12}>
          <PaymentExpectedReceipt />
        </Grid>
      ) : null}

      {Role?.filter((i) => i.ROLE_ID !== 11).length > 0 &&
      (userRole?.filter((i) => i.COMPONENT_NAME == 'InvoiceRefund').length >
        0 ||
        invoiceData[0]?.Consumer?.ConsumerType == 2 ||
        invoiceData[0]?.Consumer?.ConsumerType == 3) ? (
        <InvoiceRefund />
      ) : null}
      <Grid item xs={12}>
        {invoiceData[0]?.Consumer.UpTypeId == 7 &&
        [23, 14, 15, 31, 32, 33].includes(invoiceData[0]?.Exchange?.Status) &&
        (invoiceData[0]?.Apply.BrandCode === 3 ||
          invoiceData[0]?.Apply.BrandCode === 4) &&
        invoiceData[0]?.Consumer?.ConsumerType === 1 &&
        !topProductIds.includes(invoiceData[0]?.Model?.TopProductId) &&
        invoiceData[0]?.Exchange.IsAirConditionerProduct === 0 &&
        Role?.filter((i) => i.ROLE_ID !== 11).length > 0 ? (
          <WebPoint />
        ) : null}
      </Grid>
      {/* <Grid item xs={12} style={{ paddingTop: 5 }}>
        {(invoiceData[0]?.Consumer.UpTypeId == 7 && invoiceData[0]?.Exchange.GPSNO != 0 && invoiceData[0]?.Exchange?.Status === 31) ? <WebPointCancel /> : null}
      </Grid> */}
      <Grid item xs={12} style={{ paddingTop: 5 }}>
        {/* Sonradan düzeltilecektir. */}
        {Role?.filter((i) => i.ROLE_ID !== 11).length > 0 ? (
          <ApprovalProcess />
        ) : null}
      </Grid>
      <Grid item xs={12}>
        {invoiceData[0]?.Consumer?.ConsumerType == 3 &&
        Role?.filter((i) => i.ROLE_ID !== 11).length > 0 ? (
          <DirectionProcess />
        ) : invoiceData[0]?.Consumer?.ConsumerType != 3 &&
          invoiceData[0]?.Exchange?.ExchangeResonMain == 90 &&
          Role?.filter((i) => i.ROLE_ID !== 11).length > 0 ? (
          <DirectionProcess />
        ) : null}
      </Grid>
    </>
  );
}

export default InformationChat;
